
import {
    AuditEscalationGroupModel,
    AuditFaultTypeModel,
    AuditModel,
    AuditWorkplaceModel,
    CustomerModel,
    EscalationGroupTypeEnum,
    PlanItemEscalationModel,
    PlanItemModel,
    PlanItemStateEnum,
    ProcessTypeEnum,
    ProductModel,
    ProjectModel,
    StationModel,
    TenantUserModel,
    WorkplaceModel,
} from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { auditsStore } from '@/libs/audits/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { auditFaultTypesStore } from '@/libs/audit-fault-types/+state/store';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { auditWorkplacesStore } from '@/libs/audit-workplaces/+state/store';
import { planItemsStore } from '@/libs/plan-items/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import moment from 'moment/moment';
import { auditEscalationGroupsStore } from '@/libs/audit-escalation-groups/+state/store';
import { customersStore } from '@/libs/customers/+state/store';
import { productsStore } from '@/libs/products/+state/store';
import { projectsStore } from '@/libs/projects/+state/store';
import { validate as isValidUUID } from 'uuid';
import { stationsStore } from '@/libs/stations/+state/store';
import { workplacesStore } from '@/libs/workplaces/+state/store';
import ConfirmDialog from '@/libs/common/components/ConfirmDialog.vue';

@Component({
    components: { ConfirmDialog },
})
export default class IssuesSolving extends Page {
    tenantUser: TenantUserModel = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
    faultTypes: AuditFaultTypeModel[] = [];
    auditWorkplaces: AuditWorkplaceModel[] = [];
    customers: CustomerModel[] = [];
    products: ProductModel[] = [];
    projects: ProjectModel[] = [];
    auditEscalationGroups: AuditEscalationGroupModel[] = [];
    @Prop() tenantId!: string;
    @Prop() auditId!: string;
    protected activeWorkplaceId: string | null = null;
    protected activeStationId: string | null = null;
    protected activeCustomerId: string | null = null;
    protected activeProductId: string | null = null;
    protected activeProjectId: string | null = null;
    protected activeFaultTypeId: string | null = null;
    protected otherCustomersDialog = false;
    protected otherProductsDialog = false;
    protected otherProjectsDialog = false;
    protected selectEscalationDialog = false;
    protected savingSelfRepair = false;
    protected savingEscalationGroup: string | null = null;
    protected filterCustomerName: string | null = null;
    protected filterProductName: string | null = null;
    protected filterProjectName: string | null = null;
    protected shutdownFromDate: string | null = null;
    protected minItemsLength = 5;
    protected priorityWorkplaces: string[] = [];
    protected showAllWorkplaces = false;
    protected showAllStations = false;

    protected duplicateConfirmDialog = false;
    protected duplicateExistingTime: string | null = null;
    protected pendingSelfRepair = false;
    protected pendingEscalationGroups: PlanItemEscalationModel[] = [];
    protected pendingGoToAudit = false;

    protected get canChnageWorkplace(): boolean {
        return this.getQuery('workplaceId') == null;
    }

    protected get isLoading(): boolean {
        return auditsStore.useGetter(CrudGetter.Pending) || auditFaultTypesStore.useGetter(CrudGetter.Pending);
    }

    protected get isSaving(): boolean {
        return planItemsStore.useGetter(CrudGetter.Saving);
    }

    protected get audit(): AuditModel {
        return auditsStore.useGetter(CrudGetter.Detail, this.auditId);
    }

    protected get activeWorkplace(): WorkplaceModel | undefined {
        return this.auditWorkplaces.find((x) => x.workplaceId == this.activeWorkplaceId)?.workplace;
    }

    protected get activeStation(): StationModel | null {
        let stations: StationModel[] = stationsStore.useGetter(CrudGetter.Data) ?? [];
        stations = stations.filter((x) => x.workplaceId == this.activeWorkplaceId);
        return stations.find((x) => x.id == this.activeStationId) ?? null;
    }

    protected get activeCustomer(): CustomerModel | undefined {
        return this.customers.find((x) => x.id == this.activeCustomerId);
    }

    protected get activeProduct(): ProductModel | undefined {
        return this.products.find((x) => x.id == this.activeProductId);
    }

    protected get activeProject(): ProjectModel | undefined {
        return this.projects.find((x) => x.id == this.activeProjectId);
    }

    protected get activeFaultType(): AuditFaultTypeModel | undefined {
        return this.faultTypes.find((x) => x.id == this.activeFaultTypeId);
    }

    public get customerShortList(): CustomerModel[] {
        return this.customers.slice(0, this.minItemsLength);
    }

    public get productShortList(): ProductModel[] {
        return this.products.slice(0, this.minItemsLength);
    }

    public get projectShortList(): ProjectModel[] {
        return this.projects.slice(0, this.minItemsLength);
    }

    public get priorityAuditWorkplaces(): AuditWorkplaceModel[] {
        if (this.priorityWorkplaces.length > 0 && !this.showAllWorkplaces) {
            return this.auditWorkplaces.filter((x) => this.priorityWorkplaces.contains(x.workplaceId!));
        }
        return this.auditWorkplaces;
    }

    public get workplaceStations(): StationModel[] {
        if (!this.activeWorkplaceId) {
            return [];
        }
        const stations: StationModel[] = stationsStore.useGetter(CrudGetter.Data) ?? [];
        return stations.filter((x) => x.workplaceId == this.activeWorkplaceId);
    }

    public get priorityStations(): StationModel[] {
        try {
            if (!this.showAllStations) {
                let activeStations: string[] = [];
                try {
                    activeStations = JSON.parse(window.localStorage.ActiveStation) ?? [];
                } catch (e) {
                    // ts-ignore
                }
                if (activeStations.length > 0) {
                    let stations: StationModel[] = stationsStore.useGetter(CrudGetter.Data) ?? [];
                    stations = stations.filter(
                        (x) => x.workplaceId == this.activeWorkplaceId && activeStations.contains(x.id!)
                    );
                    if (stations.length > 0) {
                        return stations;
                    }
                }
            }
            return this.workplaceStations;
        } catch (e) {
            // ts-ignore
        }
        return [];
    }

    protected get duplicateExistingTimeFormatted(): string {
        return this.duplicateExistingTime ? moment(this.duplicateExistingTime).format('DD.MM.YYYY HH:mm') : '';
    }

    public get filteredCustomerList(): CustomerModel[] {
        if (!this.filterCustomerName) {
            return [...this.customers];
        }
        return [...this.customers].filter((x) => {
            if (!x.name) return false;

            const filterGroups = (this.filterCustomerName || '')
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '') // Remove accents
                .split(/[^a-z0-9]+/) // Split by non-alphanumeric characters
                .filter((group) => group.trim().length > 0); // Remove any empty groups

            const normalizedName = x
                .name!.toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');

            return filterGroups.some((group) => {
                let typosAllowed = 3; // Adjust typo tolerance
                return (
                    normalizedName.includes(group) ||
                    group.split('').some((char, i) => {
                        const typoCheckGroup = group.slice(0, i) + group.slice(i + 1);
                        return normalizedName.includes(typoCheckGroup);
                    }) ||
                    group.split('').some((char, i) => {
                        for (let charCode = 97; charCode <= 122; charCode++) {
                            // Check with other characters (a-z)
                            const replacedGroup = group.slice(0, i) + String.fromCharCode(charCode) + group.slice(i + 1);
                            if (normalizedName.includes(replacedGroup)) {
                                return true;
                            }
                        }
                        return false;
                    })
                );
            });
        });
    }

    public get filteredProductList(): ProductModel[] {
        if (!this.filterProductName) {
            return [...this.products];
        }
        return [...this.products].filter((x) => {
            if (!x.name) return false;

            const filterGroups = (this.filterProductName || '')
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '') // Remove accents
                .split(/[^a-z0-9]+/) // Split by non-alphanumeric characters
                .filter((group) => group.trim().length > 0); // Remove any empty groups

            const normalizedName = x
                .name!.toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');

            return filterGroups.some((group) => {
                let typosAllowed = 3; // Adjust typo tolerance
                return (
                    normalizedName.includes(group) ||
                    group.split('').some((char, i) => {
                        const typoCheckGroup = group.slice(0, i) + group.slice(i + 1);
                        return normalizedName.includes(typoCheckGroup);
                    }) ||
                    group.split('').some((char, i) => {
                        for (let charCode = 97; charCode <= 122; charCode++) {
                            // Check with other characters (a-z)
                            const replacedGroup = group.slice(0, i) + String.fromCharCode(charCode) + group.slice(i + 1);
                            if (normalizedName.includes(replacedGroup)) {
                                return true;
                            }
                        }
                        return false;
                    })
                );
            });
        });
    }

    public get filteredProjectList(): ProductModel[] {
        if (!this.filterProjectName) {
            return [...this.projects];
        }
        return [...this.projects].filter((x) => {
            if (!x.name) return false;

            const filterGroups = (this.filterProjectName || '')
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '') // Remove accents
                .split(/[^a-z0-9]+/) // Split by non-alphanumeric characters
                .filter((group) => group.trim().length > 0); // Remove any empty groups

            const normalizedName = x
                .name!.toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');

            return filterGroups.some((group) => {
                let typosAllowed = 3; // Adjust typo tolerance
                return (
                    normalizedName.includes(group) ||
                    group.split('').some((char, i) => {
                        const typoCheckGroup = group.slice(0, i) + group.slice(i + 1);
                        return normalizedName.includes(typoCheckGroup);
                    }) ||
                    group.split('').some((char, i) => {
                        for (let charCode = 97; charCode <= 122; charCode++) {
                            // Check with other characters (a-z)
                            const replacedGroup = group.slice(0, i) + String.fromCharCode(charCode) + group.slice(i + 1);
                            if (normalizedName.includes(replacedGroup)) {
                                return true;
                            }
                        }
                        return false;
                    })
                );
            });
        });
    }

    protected get isShutdownFromDateInFuture() {
        return this.shutdownFromDate && new Date(this.shutdownFromDate) > new Date();
    }

    protected get isShutdownFromDateTooOld() {
        if (!this.shutdownFromDate) return false;
        const threeHoursAgo = new Date(new Date().getTime() - (3 * 60 * 60 + 5 * 60) * 1000);
        return new Date(this.shutdownFromDate) < threeHoursAgo;
    }

    async mounted() {
        this.activeWorkplaceId = this.getQuery('workplaceId') ?? null;
        await this.getAudit();
        Promise.all([
            this.getFaultTypes(),
            this.getAuditWorkplaces(),
            this.getAuditEscalationGroups(),
            this.getCustomers(),
            this.getProducts(),
            this.getProjects(),
        ]).then(() => {
            this.priorityWorkplaces = [];
            if (window.localStorage.ActiveWorkplace) {
                const activeWorkplace = window.localStorage.ActiveWorkplace;
                let isValidGuid = false;
                try {
                    isValidGuid = isValidUUID(activeWorkplace);
                } catch (e) {
                    // ts-ignore
                }
                if (isValidGuid) {
                    const activeWorkplaceId = window.localStorage.ActiveWorkplace;
                    if (this.auditWorkplaces.some((x) => x.workplaceId == activeWorkplaceId)) {
                        this.activeWorkplaceId = activeWorkplaceId;
                    }
                } else {
                    try {
                        const activeWorkplaces = JSON.parse(window.localStorage.ActiveWorkplace) as string[];
                        if (activeWorkplaces) {
                            if (activeWorkplaces.length == 1) {
                                const activeWorkplaceId = activeWorkplaces[0];
                                if (this.auditWorkplaces.some((x) => x.workplaceId == activeWorkplaceId)) {
                                    this.activeWorkplaceId = activeWorkplaceId;
                                }
                            } else if (activeWorkplaces.length > 1) {
                                this.priorityWorkplaces = activeWorkplaces;
                            }
                        }
                    } catch (e) {
                        // ts-ignore
                    }
                    try {
                        const activeStations = JSON.parse(window.localStorage.ActiveStation) as string[];
                        if (activeStations) {
                            if (activeStations.length == 1) {
                                const activeStationId = activeStations[0];
                                const stations: StationModel[] = stationsStore.useGetter(CrudGetter.Data) ?? [];
                                const station = stations.find(
                                    (x) => x.workplaceId == this.activeWorkplaceId && x.id == activeStationId
                                );
                                this.activeStationId = station?.id ?? null;
                            }
                        }
                    } catch (e) {
                        // ts-ignore
                    }
                }
            }
        });
    }

    getAudit(): Promise<AuditModel> {
        return new Promise((resolve, reject) => {
            auditsStore.dispatch(CrudAction.Get, { id: this.auditId, key: this.auditId });
            this.subscribe(auditsStore, CrudReponse.Get, this.auditId)
                .then((audit: AuditModel) => {
                    resolve(audit);
                })
                .catch(reject);
        });
    }

    getFaultTypes(): Promise<AuditFaultTypeModel[]> {
        return new Promise((resolve, reject) => {
            auditFaultTypesStore.dispatch(
                CrudAction.GetAll,
                createCrudQueryPayload({ field: 'name', index: 1, order: 'asc' }, [
                    { field: 'auditId', op: 'eq', comparand: this.auditId },
                    { field: 'isActive', op: 'eq', comparand: true },
                ])
            );
            this.subscribe(auditFaultTypesStore, CrudReponse.GetAll)
                .then((auditFaultTypes: AuditFaultTypeModel[]) => {
                    this.faultTypes = auditFaultTypes;
                    resolve(auditFaultTypes);
                })
                .catch(reject);
        });
    }

    getAuditWorkplaces(): Promise<AuditWorkplaceModel[]> {
        return new Promise((resolve, reject) => {
            if (this.audit.useWorkplaceLimitation) {
                auditWorkplacesStore.dispatch(
                    CrudAction.GetAll,
                    createCrudQueryPayload({ field: 'workplace.name', index: 1, order: 'asc' }, [
                        {
                            field: 'auditId',
                            op: 'eq',
                            comparand: this.auditId,
                        },
                    ])
                );
                this.subscribe(auditWorkplacesStore, CrudReponse.GetAll)
                    .then((auditWorkplaces: AuditWorkplaceModel[]) => {
                        this.auditWorkplaces = auditWorkplaces;
                        resolve(auditWorkplaces);
                    })
                    .catch(reject);
            } else {
                const workplaces: WorkplaceModel[] = workplacesStore.useGetter(CrudGetter.Data) ?? [];
                this.auditWorkplaces = workplaces.map((x) => {
                    return {
                        workplace: x,
                        workplaceId: x.id,
                        id: x.id,
                    };
                });
                resolve(this.auditWorkplaces);
            }
        });
    }

    getCustomers(): Promise<CustomerModel[]> {
        return new Promise((resolve, reject) => {
            customersStore.dispatch(CrudAction.GetAll, createCrudQueryPayload({ field: 'name', index: 1, order: 'asc' }, []));
            this.subscribe(customersStore, CrudReponse.GetAll)
                .then((customers: CustomerModel[]) => {
                    this.customers = customers;
                    resolve(customers);
                })
                .catch(reject);
        });
    }

    getProducts(): Promise<ProductModel[]> {
        return new Promise((resolve, reject) => {
            productsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload({ field: 'name', index: 1, order: 'asc' }, []));
            this.subscribe(productsStore, CrudReponse.GetAll)
                .then((products: ProductModel[]) => {
                    this.products = products;
                    resolve(products);
                })
                .catch(reject);
        });
    }

    getProjects(): Promise<ProjectModel[]> {
        return new Promise((resolve, reject) => {
            projectsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload({ field: 'name', index: 1, order: 'asc' }, []));
            this.subscribe(projectsStore, CrudReponse.GetAll)
                .then((projects: ProjectModel[]) => {
                    this.projects = projects;
                    resolve(projects);
                })
                .catch(reject);
        });
    }

    getAuditEscalationGroups(): Promise<AuditEscalationGroupModel[]> {
        return new Promise((resolve, reject) => {
            auditEscalationGroupsStore.dispatch(
                CrudAction.GetAll,
                createCrudQueryPayload({ field: 'group.name', index: 1, order: 'asc' }, [
                    {
                        field: 'auditId',
                        op: 'eq',
                        comparand: this.auditId,
                    },
                    {
                        field: 'escalationGroupType',
                        op: 'eq',
                        comparand: EscalationGroupTypeEnum.IssueEscalation,
                    },
                ])
            );
            this.subscribe(auditEscalationGroupsStore, CrudReponse.GetAll)
                .then((auditEscalationGroups: AuditWorkplaceModel[]) => {
                    this.auditEscalationGroups = auditEscalationGroups;
                    resolve(auditEscalationGroups);
                })
                .catch(reject);
        });
    }

    activeFaultTypeChanged(faultTypeId: string | null) {
        this.activeFaultTypeId = faultTypeId;
    }

    activeStationChanged(stationId: string | null) {
        this.activeStationId = stationId;
    }

    activeWorkplaceChanged(workplaceId: string | null) {
        this.activeWorkplaceId = workplaceId;
        this.activeStationId = null;
    }

    activeCustomerChanged(customerId: string | null) {
        this.activeCustomerId = customerId;
        this.otherCustomersDialog = false;
    }

    activeProductChanged(productId: string | null) {
        this.activeProductId = productId;
        this.otherProductsDialog = false;
    }

    activeProjectChanged(projectId: string) {
        this.activeProjectId = projectId;
        this.otherProjectsDialog = false;
    }

    onOtherCustomersClick() {
        this.filterCustomerName = null;
        this.otherCustomersDialog = true;
    }

    onOtherProductsClick() {
        this.filterProductName = null;
        this.otherProductsDialog = true;
    }

    onOtherProjectsClick() {
        this.filterProjectName = null;
        this.otherProjectsDialog = true;
    }

    onReportClick() {
        const activeFaultType = this.faultTypes.find((x) => x.id == this.activeFaultTypeId);
        if (activeFaultType && activeFaultType.isWorkplaceShutdown) {
            this.shutdownFromDate = moment().format('YYYY-MM-DDTHH:mm:ss');
        } else {
            this.shutdownFromDate = null;
        }
        this.selectEscalationDialog = true;
    }

    onCloseEscalationClick() {
        this.selectEscalationDialog = false;
    }

    onCloseOtherCustomersClick() {
        this.otherCustomersDialog = false;
    }

    onCloseOtherProductsClick() {
        this.otherProductsDialog = false;
    }

    onCloseOtherProjectsClick() {
        this.otherProjectsDialog = false;
    }

    selfRepairAndStartSolving() {
        this.savingSelfRepair = true;
        const groups: PlanItemEscalationModel[] = [
            {
                tenantUserId: this.tenantUser.id,
            },
        ];
        this.checkDuplicateAndProceed(true, groups, true);
    }

    onShutdownFromDateAddMinutes(minutes: number) {
        if (!this.shutdownFromDate) {
            this.shutdownFromDate = moment().format('YYYY-MM-DDTHH:mm:ss');
        }
        this.shutdownFromDate = moment(this.shutdownFromDate, 'YYYY-MM-DDTHH:mm:ss')
            .add(minutes, 'minutes')
            .format('YYYY-MM-DDTHH:mm:ss');
    }

    couldBeDateAddMinutesInFuture(minutes: number) {
        if (!this.shutdownFromDate) {
            return true;
        }
        return new Date(this.shutdownFromDate).getTime() + minutes * 60 * 1000 > new Date().getTime();
    }

    couldBeDateAddMinutesTooOld(minutes: number) {
        // If date is not selected yet, we allow decreasing by an hour (it will set to now first)
        if (!this.shutdownFromDate) {
            return false;
        }
        const target = new Date(new Date(this.shutdownFromDate).getTime() + minutes * 60 * 1000);
        const threeHoursAgo = new Date(new Date().getTime() - (3 * 60 * 60 + 5 * 60) * 1000);
        return target < threeHoursAgo;
    }

    escalateAndStartSolving(escalationGroup: AuditEscalationGroupModel) {
        this.savingEscalationGroup = escalationGroup.id!;
        const groups: PlanItemEscalationModel[] = [
            {
                groupId: escalationGroup.groupId!,
            },
            {
                tenantUserId: this.tenantUser.id,
            },
        ];
        this.checkDuplicateAndProceed(false, groups, false);
    }

    checkDuplicateAndProceed(selfRepair: boolean, escalationGroups: PlanItemEscalationModel[], goToAudit: boolean) {
        this.pendingSelfRepair = selfRepair;
        this.pendingEscalationGroups = escalationGroups;
        this.pendingGoToAudit = goToAudit;

        const predicates: any[] = [
            { field: 'processType', op: 'eq', comparand: ProcessTypeEnum.IssueSolving },
            { field: 'auditFaultTypeId', op: 'eq', comparand: this.activeFaultTypeId },
            { field: 'workplaceId', op: 'eq', comparand: this.activeWorkplaceId },
        ];
        if (this.audit.category && this.audit.category.useStation && this.activeStationId) {
            predicates.push({ field: 'stationId', op: 'eq', comparand: this.activeStationId });
        }
        predicates.push({
            field: 'id',
            op: 'wrap',
            comparand: [
                { field: 'planItemState', op: 'eq', comparand: 'WaitingToPerform', junction: 'or' },
                {
                    field: 'id',
                    op: 'wrap',
                    comparand: [
                        { field: 'isWorkplaceShutdown', op: 'eq', comparand: true },
                        { field: 'shutdownToDate', op: 'eq', comparand: null },
                    ],
                    junction: 'or',
                },
            ],
        });

        planItemsStore.dispatch(
            CrudAction.GetAllBasic,
            createCrudQueryPayload<PlanItemModel>(
                { field: 'time', index: 1, order: 'desc' },
                predicates,
                { pageIndex: 1, pageSize: 1 },
                false,
                'ReportIssueDuplicateCheck',
                true
            )
        );
        this.subscribe(planItemsStore, CrudReponse.GetAllBasic, 'ReportIssueDuplicateCheck')
            .then((items: PlanItemModel[]) => {
                if (items && items.length > 0) {
                    this.duplicateExistingTime = items[0].time as string;
                    this.duplicateConfirmDialog = true;
                } else {
                    this.save(this.pendingSelfRepair, this.pendingEscalationGroups, this.pendingGoToAudit);
                }
            })
            .catch(() => {
                // Pokud kontrola selže, pro jistotu pokračuj v uložení
                this.save(this.pendingSelfRepair, this.pendingEscalationGroups, this.pendingGoToAudit);
            });
    }

    onDuplicateConfirmed() {
        this.duplicateConfirmDialog = false;
        this.save(this.pendingSelfRepair, this.pendingEscalationGroups, this.pendingGoToAudit);
    }

    onDuplicateDeclined() {
        this.duplicateConfirmDialog = false;
        this.savingSelfRepair = false;
        this.savingEscalationGroup = null;
    }

    save(selfRepair: boolean, escalationGroups: PlanItemEscalationModel[], goToAudit: boolean) {
        const activeFaultType = this.faultTypes.find((x) => x.id == this.activeFaultTypeId);
        const planItem: PlanItemModel = {
            id: Guid.EmptyGuid(),
            time: moment().format('YYYY-MM-DDTHH:mm:ss'),
            since: moment().format('YYYY-MM-DDTHH:mm:ss'),
            until: moment().format('YYYY-MM-DDTHH:mm:ss'),
            auditId: this.auditId,
            customerId: this.activeCustomerId,
            productId: this.activeProductId,
            projectId: this.activeProjectId,
            planItemState: PlanItemStateEnum.Reported,
            workplaceId: this.activeWorkplaceId,
            stationId: this.activeStationId,
            auditFaultTypeId: this.activeFaultTypeId,
            tenantUserId: selfRepair ? this.tenantUser.id : null,
            reportedById: this.tenantUser.id,
            processType: ProcessTypeEnum.IssueSolving,
            escalations: escalationGroups,
            shutdownFromDate: this.shutdownFromDate,
            isWorkplaceShutdown: activeFaultType?.isWorkplaceShutdown == true,
            performations: [
                {
                    tenantUserId: this.tenantUser.id,
                    fromDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
                    sequenceIndex: 0,
                },
            ],
            shiftId: this.getQuery('shiftId') ?? null,
        };
        planItemsStore.dispatch(CrudAction.Create, { item: planItem });
        this.subscribe(planItemsStore, CrudReponse.Create).then((e: PlanItemModel) => {
            this.selectEscalationDialog = false;
            this.savingSelfRepair = false;
            this.savingEscalationGroup = null;
            if (goToAudit) {
                this.$router.push({ name: 'WorkTaskAuditFormExisting', params: { id: e.id! } });
            } else {
                this.$router.push({ name: 'IssuesSolving' });
            }
        });
    }
}
